var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-aos":"fade-right"}},[(_vm.templateNumber === 1)?_c('Events1',{attrs:{"events":_vm.events}}):(_vm.templateNumber === 2)?_c('Events2',{attrs:{"events":_vm.events}}):(_vm.templateNumber === 3)?_c('Events4',{attrs:{"events":_vm.events}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }